import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Invoice\ReorderInvoiceItemsController::__invoke
* @see app/Http/Controllers/Invoice/ReorderInvoiceItemsController.php
* @route '/api/invoicing/{invoice}/invoice-item/{invoice_item}/reorder'
*/
const ReorderInvoiceItemsController = (args: { invoice: string | number | { id: string | number }, invoice_item: string | number | { id: string | number } } | [invoice: string | number | { id: string | number }, invoice_item: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: ReorderInvoiceItemsController.url(args, options),
    method: 'put',
})

ReorderInvoiceItemsController.definition = {
    methods: ["put"],
    url: '/api/invoicing/{invoice}/invoice-item/{invoice_item}/reorder',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Invoice\ReorderInvoiceItemsController::__invoke
* @see app/Http/Controllers/Invoice/ReorderInvoiceItemsController.php
* @route '/api/invoicing/{invoice}/invoice-item/{invoice_item}/reorder'
*/
ReorderInvoiceItemsController.url = (args: { invoice: string | number | { id: string | number }, invoice_item: string | number | { id: string | number } } | [invoice: string | number | { id: string | number }, invoice_item: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            invoice: args[0],
            invoice_item: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        invoice: typeof args.invoice === 'object'
        ? args.invoice.id
        : args.invoice,
        invoice_item: typeof args.invoice_item === 'object'
        ? args.invoice_item.id
        : args.invoice_item,
    }

    return ReorderInvoiceItemsController.definition.url
            .replace('{invoice}', parsedArgs.invoice.toString())
            .replace('{invoice_item}', parsedArgs.invoice_item.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Invoice\ReorderInvoiceItemsController::__invoke
* @see app/Http/Controllers/Invoice/ReorderInvoiceItemsController.php
* @route '/api/invoicing/{invoice}/invoice-item/{invoice_item}/reorder'
*/
ReorderInvoiceItemsController.put = (args: { invoice: string | number | { id: string | number }, invoice_item: string | number | { id: string | number } } | [invoice: string | number | { id: string | number }, invoice_item: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: ReorderInvoiceItemsController.url(args, options),
    method: 'put',
})

export default ReorderInvoiceItemsController